/*
 * @Description: 枚举常量
 */

export const letterArr: Array<string> = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z",];

 //门户-跳转链接
 //跳转链接
import { isMobile } from '@/utils/validate'

export const JumpLink: object[] = [
    {
        value: 'link',
        label: '自定义链接'
    },
    {
        value: 'course',
        label: '课程'
    },
    {
        value: 'micro',
        label: '微页面'
    },
]
 //门户-课程查看全部跳转链接
 export const CourseMoreLink: object[] = [
    {
        value: 'default',
        label: '默认地址'
    },
    {
        value: 'link',
        label: '自定义链接'
    },
    {
        value: 'course',
        label: '课程'
    },
    {
        value: 'micro',
        label: '微页面'
    },
]
 //课程来源
 export const CourseSourceType: { value: string, label: string }[] = [
    {
        value: '0',
        label: '本校课程'
    },
    {
        value: '1',
        label: '华文慕课'
    },
    // {
    //     value: '2',
    //     label: '苏州国际教育'
    // },
    {
        value: '3',
        label: '中国大学MOOC'
    },
    {
        value: '5',
        label: '智慧树'
    },
    {
        value: '7',
        label: '学堂在线'
    },
    {
        value: '4',
        label: '高校邦'
    },
   {
     value: '6',
     label: '学银在线'
   },
   {
    value: '8',
    label: '超星泛雅'
   },
   {
    value: '9',
    label: 'edx'
   },
   {
    value: '10',
    label: 'coursera'
   },
]
 //门户-跳转链接
 export const SemesterType: object[] = [
    {
        value: '0',
        label: '全年'
    },
    {
        value: '1',
        label: '上学期'
    },
    {
        value: '2',
        label: '下学期'
    },
]
 //导航菜单
 export const pageNavList: { value: string; label: string; }[] = [
    {
        value: 'pc_slideshow',
        label: '轮播图'
    },
    {
        value: 'pc_classify',
        label: '分类导航'
    },
    {
        value: 'pc_course',
        label: '课程'
    },
    {
        value: 'pc_richText',
        label: '富文本'
    },
    {
        value: 'pc_article',
        label: '文章'
    },
    {
        value: 'pc_dataDisplay',
        label: '数据展示'
    },
]

// PC课堂派地址
export const ktpUrl = (function (){
    if(process.env.NODE_ENV === 'production' && process.env.VUE_APP_ENV === 'test' || process.env.NODE_ENV === 'development') {
        if(isMobile()) {
            return '//testh5.webtest.ketangpai.com/'
        }
        return '//pc.webtest.ketangpai.com/#/';
    } else {
        if(isMobile()) {
            return '//w.ketangpai.com/'
        }
        return '//ketangpai.com/#/'
    }
})()

 //导航菜单
 export const dataType: object[] = [
    {
        value: '1',
        label: '平台数据'
    },
    {
        value: '2',
        label: '已认证数据'
    },
    
    // {
    //     value: '3',
    //     label: '慕课数据'
    // }
]
//看板管理tabs
export const panelTypeList: object[] = [
    {
        value: '1',
        label: '我的看板'
    },
    {
        value: '2',
        label: '分享给我的'
    },
    {
        value: '0',
        label: '系统预置'
    },
    {
        value: 'all',
        label: '全部看板'
    },
]
//指标管理tabs
export const indicatorTypeList: object[] = [
    {
        value: '1',
        label: '我的指标'
    },
    // {
    //     value: '2',
    //     label: '分享给我的'
    // },
    {
        value: '3',
        label: '系统预置'
    },
]
//指标管理tabs
export const addTypeList: {value: string, label: string}[] = [
    {
        value: '1',
        label: '我的看板'
    },
    // {
    //     value: '2',
    //     label: '分享给我的'
    // },
    {
        value: '0',
        label: '系统预置'
    },
    // {
    //     value: 'all',
    //     label: '全部看板'
    // },
]
//事件管理tabs
export const incidentTypeList: object[] = [
    {
        value: '0',
        label: '预定义事件'
    },
    {
        value: '1',
        label: '计算事件'
    }
]
//事件管理tabs
export const liveClassroomTypeList: object[] = [
    {
        value: '1',
        label: '实时直播'
    },
    {
        value: '2',
        label: '实时录屏'
    },
    {
        value: '3',
        label: '实时会议'
    }
]
//课堂教学监控布局类型
export const liveLayout: object[] = [
    {
        value: '4',
        label: '4屏'
    },
    {
        value: '6',
        label: '6屏'
    },
    {
        value: '8',
        label: '8屏'
    },
    {
        value: '9',
        label: '9屏'
    },
    {
        value: '12',
        label: '12屏'
    },
    {
        value: '16',
        label: '16屏'
    }
]
//录像类型
export const liveVideoType: object[] = [
    {
        value: '-1',
        label: '全部录像'
    },
    {
        value: '1',
        label: '直播录像'
    },
    {
        value: '2',
        label: '录屏录像'
    },
    {
        value: '3',
        label: '会议直播录像'
    }
]
//直播类型
export const livePlatform: object[] = [
    {
        value: '0',
        label: '全部直播'
    },
    {
        value: '1',
        label: '课堂派直播'
    },
    {
        value: '2',
        label: '腾讯会议直播'
    },
]
//直播数据类型
export const liveDataType: object[] = [
    {
        value: '0',
        label: '全部课程'
    },
    {
        value: '1',
        label: '课表课程'
    },
]
//课程学期
export const courseSemester: object[] = [
    {
        value: '0',
        label: '全年学期'
    },
    {
        value: '1',
        label: '第一学期'
    },
    {
        value: '2',
        label: '第二学期'
    },
]
//课程管理认证类型
export const courseCertification: object[] = [
    {
        value: '2',
        label: '全部'
    },
    {
        value: '1',
        label: '已认证'
    },
    {
        value: '0',
        label: '未认证'
    },
]

//课程管理 --课程统计类型
export const statisticsType: object[] = [
    {
        value: '0',
        label: '已加课学生'
    },
    {
        value: '8',
        label: '协作团队'
    },
    {
        value: '1',
        label: '资料'
    },
    {
        value: '2',
        label: '作业'
    },
    {
        value: '3',
        label: '互动'
    },
    {
        value: '4',
        label: '测试'
    },
    {
        value: '5',
        label: '考勤'
    },
    {
        value: '6',
        label: '表现'
    },
    {
        value: '7',
        label: '公告'
    },
]
//系统操作日志动作类型

export const actionType: object[] = [
    {
        value: '0',
        label: '全部动作'
    },
    {
        value: '1',
        label: '批量导入'
    }, 
    {
        value: '2',
        label: '权限管理'
    }, 
    {
        value: '3',
        label: '编辑'
    }, 
    {
        value: '4',
        label: '删除'
    }, 
    {
        value: '5',
        label: '发布通知'
    },  
]

//录播教室类型
export const recordedBroadcastType: object[] = [
    {
        value: '2',
        label: '全部录播教室'
    },
    {
        value: '1',
        label: '在线录播教室'
    },
    {
        value: '0',
        label: '离线录播教室'
    },
    
]
//巡课类型
export const inspectopenType: object[] = [
    {
        value: "3",
        label: '待巡课'
    },
    {
        value: "2",
        label: '已巡课'
    },
    {
        value: "1",
        label: '全部'
    },
    
]

